import type { CategoryFail } from './CategoryFail';
import type { SubCategoryFail } from './SubCategoryFail';

export enum FAIL_REPORT_WARRANTY {
  YES = 0,
  NO = 1,
  UNKNOWN = 2,
  NOT_APPLICABLE = 3,
}

export const FailReportWarrantyString: Record<FAIL_REPORT_WARRANTY, string> = {
  [FAIL_REPORT_WARRANTY.YES]: 'Sí',
  [FAIL_REPORT_WARRANTY.NO]: 'No',
  [FAIL_REPORT_WARRANTY.UNKNOWN]: 'Desconocido',
  [FAIL_REPORT_WARRANTY.NOT_APPLICABLE]: 'No aplica',
};

export enum FAIL_REPORT_STATUS {
  INSTANCE_1 = 1,
  INSTANCE_2 = 2,
  STATUS_PENDING = 3,
  RESOLVED = 4,
  CLOSED = 5,
  CANCELED = 6,
}

export const FailReportStatusString: Record<FAIL_REPORT_STATUS, string> = {
  [FAIL_REPORT_STATUS.INSTANCE_1]: 'Instancia 1 - Inicial',
  [FAIL_REPORT_STATUS.INSTANCE_2]: 'Instancia 2 - En revisión',
  [FAIL_REPORT_STATUS.STATUS_PENDING]: 'Pendiente de revisión',
  [FAIL_REPORT_STATUS.RESOLVED]: 'Resuelto',
  [FAIL_REPORT_STATUS.CLOSED]: 'Cerrado',
  [FAIL_REPORT_STATUS.CANCELED]: 'Cancelado',
};

export interface FailReport {
  id?: number;
  report_date?: string;
  ticket: number;
  category: number | CategoryFail;
  subcategory?: number | SubCategoryFail;
  warranty?: FAIL_REPORT_WARRANTY;
  comments?: string;
  report_ticket?: number;
  status: FAIL_REPORT_STATUS;
  review_by?: number;
  review_date?: string;
  internal_notes?: string;
  created_automatically: boolean;
  created_by: 0;
}
